import { createFileRoute } from "@tanstack/react-router"
import { StoresBySizeReport } from "@/features/reports/components/StoresBySizeReport"
import {
  applyStoresBySizeDefaults,
  storesBySizeQuery,
  StoresBySizeSearchParams,
} from "@/features/reports/core/hooks/useStoresBySizeReport"

export const Route = createFileRoute("/(authenticated)/reports/stores-by-size")({
  validateSearch: StoresBySizeSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(storesBySizeQuery(applyStoresBySizeDefaults(search)))
  },
  component: StoresBySizeReport,
})
